/** The code the API answers a send refused for a column without a value with (PREC-4440). */
const MISSING_COLUMN_VALUE_CODE = "MISSING_COLUMN_VALUE";

/**
 * The columns a test send was refused for, read from the API's 422 answer
 * (`{ error: "MISSING_COLUMN_VALUE", columns }`), or null for any other error. The generic error
 * rendering knows only fixed codes and would say "Something went wrong" (PREC-4440).
 */
export const missingColumnsOfRequestError = (error: unknown): string[] | null => {
	const data = (error as { data?: unknown } | null | undefined)?.data;

	if (!data || typeof data !== "object") {
		return null;
	}

	const { error: code, columns } = data as { error?: unknown; columns?: unknown };

	if (code !== MISSING_COLUMN_VALUE_CODE || !Array.isArray(columns)) {
		return null;
	}

	const names = columns.filter((name): name is string => typeof name === "string" && !!name);

	return names.length > 0 ? names : null;
};
